import React from 'react';

export const BncFraude = React.lazy(() => import('./BncFraude'));
export const BncFraudeHeader = React.lazy(() => import('./BncFraude/Header'));
export const TourismeLaurentidesPolaroid = React.lazy(
    () => import('./tourisme-laurentides/Polaroid'),
);
export const Remax = React.lazy(() => import('./Remax'));
export const JeuAideMachine = React.lazy(() => import('./jeu-aide-machine'));
export const SaqRouteProducteurs = React.lazy(() => import('./saq-route-producteurs'));
